import React, { useEffect, useState } from "react";

interface IPCheckGuardProps {
  children: React.ReactNode;
}

const IPCheckGuard: React.FC<IPCheckGuardProps> = ({ children }) => {
  const [isAllowed, setIsAllowed] = useState<boolean>(true);

  useEffect(() => {
    // Verificación inicial
    checkIPAccess();

    // Verificación periódica cada 30 segundos
    // Suficiente para detectar cambios de permisos sin sobrecargar el servidor
    const interval = setInterval(() => {
      checkIPAccess();
    }, 30000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  const checkIPAccess = async () => {
    try {
      // Get device token from localStorage to send in the check
      const deviceToken = localStorage.getItem("device_token");

      console.log("📦 [IPCheckGuard] Token from localStorage:", deviceToken);
      console.log(
        "📦 [IPCheckGuard] Token length:",
        deviceToken ? deviceToken.length : 0
      );

      // Use backend URL (same as API service)
      const API_BASE_URL =
        process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1";

      const headers: HeadersInit = {
        "Content-Type": "application/json",
      };

      // Add device token if present
      if (deviceToken) {
        headers["X-Device-Token"] = deviceToken;
        console.log("🔑 IPCheckGuard: Sending device token in check");
      } else {
        console.log("❌ IPCheckGuard: No device token found");
      }

      const response = await fetch(`${API_BASE_URL}/ip-access/check`, {
        method: "GET",
        headers: headers,
      });

      console.log("IPCheckGuard response status:", response.status);

      if (response.ok) {
        const data = await response.json();
        console.log("IPCheckGuard response data:", data);
        if (!data.is_allowed) {
          setIsAllowed(false);
          // PRESERVAR device token ANTES de limpiar
          const savedDeviceToken = localStorage.getItem("device_token");

          // Limpiar todo EXCEPTO el device_token
          const keysToRemove = [];
          for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key !== "device_token") {
              keysToRemove.push(key);
            }
          }
          keysToRemove.forEach((key) => localStorage.removeItem(key));
          sessionStorage.clear();

          // Asegurar que el token sigue ahí
          if (savedDeviceToken && !localStorage.getItem("device_token")) {
            localStorage.setItem("device_token", savedDeviceToken);
          }
        }
      } else if (response.status === 403) {
        console.log("❌ IPCheckGuard: 403 Forbidden - Access denied");
        setIsAllowed(false);
        // PRESERVAR device token ANTES de limpiar
        const savedDeviceToken = localStorage.getItem("device_token");

        // Limpiar todo EXCEPTO el device_token
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (key && key !== "device_token") {
            keysToRemove.push(key);
          }
        }
        keysToRemove.forEach((key) => localStorage.removeItem(key));
        sessionStorage.clear();

        // Asegurar que el token sigue ahí
        if (savedDeviceToken && !localStorage.getItem("device_token")) {
          localStorage.setItem("device_token", savedDeviceToken);
        }
      }
    } catch (error) {
      console.error("IP Guard: Error checking IP access", error);
    }
  };

  if (!isAllowed) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            background: "white",
            borderRadius: "20px",
            padding: "60px 40px",
            maxWidth: "600px",
            textAlign: "center",
            boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
          }}
        >
          <div style={{ fontSize: "80px", marginBottom: "20px" }}>🚫</div>
          <h1
            style={{
              color: "#dc2626",
              fontSize: "36px",
              marginBottom: "20px",
              fontWeight: "700",
            }}
          >
            Access Denied
          </h1>
          <p
            style={{
              color: "#4b5563",
              fontSize: "18px",
              lineHeight: "1.6",
              marginBottom: "15px",
            }}
          >
            Your access to this system has been revoked.
          </p>
          <p
            style={{
              color: "#6b7280",
              fontSize: "16px",
              marginTop: "30px",
            }}
          >
            To request access again, please contact
            <br />
            <strong style={{ color: "#2563eb" }}>System Administrator</strong>
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: "30px",
              padding: "12px 30px",
              background: "#2563eb",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "16px",
              cursor: "pointer",
              fontWeight: "600",
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default IPCheckGuard;
